import ComposeViewState from '../store/schema/ComposeViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('switchToReadWriteRecipient')(function switchToReadWriteRecipient(
    viewState: ComposeViewState
) {
    viewState.showCompactRecipientWell = false;
});
